import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

export const demoMarketDataHandlers = [
  // ── Market data health ────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/health`, () => {
    return HttpResponse.json({
      status: 'healthy',
      exchanges: [
        { name: 'binance', status: 'ok', latency_ms: 32, last_update: new Date().toISOString() },
        { name: 'okx', status: 'ok', latency_ms: 48, last_update: new Date().toISOString() },
      ],
    });
  }),

  // ── Symbol health ─────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/health/:symbol`, ({ params }) => {
    const symbol = params['symbol'] as string;
    return HttpResponse.json({
      symbol,
      status: 'ok',
      last_update: new Date().toISOString(),
    });
  }),

  // ── Subscriptions ─────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/subscriptions`, () => {
    return HttpResponse.json({
      subscriptions: [
        { symbol: 'BTCUSDT', exchange: 'binance', active: true },
        { symbol: 'ETHUSDT', exchange: 'binance', active: true },
        { symbol: 'SOLUSDT', exchange: 'binance', active: true },
      ],
    });
  }),

  // ── WebSocket status ──────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/ws/status`, () => {
    return HttpResponse.json({
      connected: true,
      exchanges: [
        { name: 'binance', connected: true, latency_ms: 12, reconnect_count: 0 },
        { name: 'okx', connected: true, latency_ms: 18, reconnect_count: 0 },
      ],
    });
  }),

  // ── Order book ────────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/:symbol/order-book`, ({ params }) => {
    const symbol = params['symbol'] as string;
    const isEth = symbol.toUpperCase().includes('ETH');
    const basePrice = isEth ? 3450 : 67500;

    return HttpResponse.json({
      symbol,
      bids: [
        [`${(basePrice - 0.5).toFixed(2)}`, '2.50000'],
        [`${(basePrice - 1.0).toFixed(2)}`, '5.12000'],
        [`${(basePrice - 2.0).toFixed(2)}`, '8.75000'],
        [`${(basePrice - 5.0).toFixed(2)}`, '12.30000'],
        [`${(basePrice - 10.0).toFixed(2)}`, '20.00000'],
      ],
      asks: [
        [`${(basePrice + 0.5).toFixed(2)}`, '1.80000'],
        [`${(basePrice + 1.0).toFixed(2)}`, '4.25000'],
        [`${(basePrice + 2.0).toFixed(2)}`, '7.60000'],
        [`${(basePrice + 5.0).toFixed(2)}`, '15.40000'],
        [`${(basePrice + 10.0).toFixed(2)}`, '22.10000'],
      ],
      timestamp: new Date().toISOString(),
    });
  }),

  // ── Funding rate ──────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/funding-rate/:symbol`, ({ params }) => {
    const symbol = params['symbol'] as string;
    return HttpResponse.json({
      symbol,
      rate: '0.0001',
      next_funding_time: new Date(Date.now() + 4 * 3600 * 1000).toISOString(),
    });
  }),

  // ── Mark price ────────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/market-data/mark-price/:symbol`, ({ params }) => {
    const symbol = params['symbol'] as string;
    const isEth = symbol.toUpperCase().includes('ETH');
    const isSol = symbol.toUpperCase().includes('SOL');
    const markPrice = isEth ? '3450.75' : isSol ? '142.30' : '67500.00';
    const indexPrice = isEth ? '3449.90' : isSol ? '142.25' : '67498.50';

    return HttpResponse.json({
      symbol,
      mark_price: markPrice,
      index_price: indexPrice,
      timestamp: new Date().toISOString(),
    });
  }),
];
